import { useDispatch, useSelector } from "react-redux"
import { selectTranslations } from "../../services/i18n/i18nSlice"
import { Link, useNavigate, useParams } from "react-router-dom"
import { loadOperations, setLoading} from "../../services/global/globalSlice"
import { useEffect, useState } from "react"
import { fetchEditFolder, fetchGetFolder } from "./FolderApi"
import { toast } from "react-toastify"
import SubFolders from "./_components/SubFolders"

import add_img from '../../assets/images/add.svg'
import add_blue_img from '../../assets/images/add_blue.svg'
import trash_img from '../../assets/images/trash.svg'
import copy_link_img from '../../assets/images/link.svg'
import arrow_back_img from '../../assets/images/arrow-back.svg'
import add_circle_img from '../../assets/images/folders/add.svg'
import training_img from '../../assets/images/folders/training.svg'
import folder_img from '../../assets/images/folders/folder.svg'
import lesson_img from '../../assets/images/folders/lesson.svg'
import link_img from '../../assets/images/folders/link.svg'
import file_img from '../../assets/images/folders/file.svg'
import video_img from '../../assets/images/folders/video.svg'
import users_img from '../../assets/images/folders/users.svg'
import eye_img from '../../assets/images/folders/eye.svg'
import question_img from '../../assets/images/demo/question.svg'
import edit_img from '../../assets/images/edit_blue.svg'
import edit_grey_img from '../../assets/images/edit.svg'
import right_img from '../../assets/images/right.svg'

import File from "./_components/File"

import { DndContext, closestCenter } from "@dnd-kit/core";
import { arrayMove, SortableContext, sortableKeyboardCoordinates } from "@dnd-kit/sortable";
import { useSortable, rectSortingStrategy } from "@dnd-kit/sortable";
import { KeyboardSensor, PointerSensor, useSensor, useSensors } from "@dnd-kit/core";
import { CSS } from '@dnd-kit/utilities';

import './FoldersScreen.css'
import { Dropdown} from "react-bootstrap"
import ContentCreateModal from "./_components/ContentCreateModal"
import ConfirmModal from "../../components/_modals/ConfirmModal"
import { prepareFolderData } from "./folderUtils"
import ContentEditModal from "./_components/ContentEditModal"
import FolderPermissions from "./_components/FolderPermissions"
import FolderInfo from "./_components/FolderInfo"
import { API_URL, BASE_URL, EXAMS_STATUS } from "../../config/constants"
import { randomUid } from "../../utils/utils"

import { useTour } from "@reactour/tour"
import { selectUserData, selectUserOnboarding, updateUserOnboarding } from "../../features/User/userSlice"
import { trainingsTourSteps } from "../../config/tour"

export default function SubFoldersScreen() {

    const t = useSelector(selectTranslations)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const {folder_id} = useParams()
    const [folderData, setFolderData] = useState({})
    const [showInfoModal, setShowInfoModal] = useState(false)
    const [contentModal, setContentModal] = useState({
        show: false,
        type: 'video',
    })
    const [confirmModal, setConfirmModal] = useState({
        title: "",
        text: "",
        onClose: null,
        onConfirm: null,
        confirmCta: "",
        closeCta: ""
    })
    const [selectedContent, setSelectedContent] = useState({
        type: null,
        index: null,
        show: false
    })
    const [showPermissionsModal, setShowPermissionsModal] = useState(false)
    const [isUpdated, setIsupdated] = useState(false)

    const handleClosePermissionsModal = (update=false) => {
        setShowPermissionsModal(false)
    }

    const handleCloseContentModal = () => {
        loadFolderDetails()
        setContentModal({
            ...contentModal,
            show: false
        })
    }

    const handleAddContent = (type) => {
        setContentModal({
            ...contentModal,
            show: true,
            type: type
        })
    }

    const openContent = (type, index) => {
        setSelectedContent({
            ...selectedContent,
            show: true,
            type: type,
            index: index
        })
    }

    const handleCloseSelectedContent = async (update = false, suggest_save=false) => {
        if(update){
            let _folderData = structuredClone(folderData)
            _folderData = prepareFolderData(_folderData)
            const response = await fetchEditFolder({folder_id: folder_id}, _folderData)
            if(response.success){
                toast.success(t.folder.folder_updated)
                
                setSelectedContent({
                ...selectedContent,
                show: false,
                })
            } else {
                toast.error("Errore durante la modifica della cartella")
            }
        } else {
            setSelectedContent({
                ...selectedContent,
                show: false,
            })
            if(suggest_save)
                setIsupdated(true)
        }
    }

    const loadFolderDetails = async () => {
        dispatch(setLoading(true))
        const response = await fetchGetFolder({...(folder_id && {folder_id: folder_id})})
        if (response.success){
            if(!response.data?.parent_folder_id)
                navigate("/folders", {replace:true})
            if(response.data?.links)
                response.data?.links.map(l => l['file_id']=randomUid())
            
            setFolderData(response.data)
            setIsupdated(false)
            dispatch(setLoading(false))
        } else {
            toast.error(t.training.error_loading_folder)
            dispatch(setLoading(false))
        }
    }

    const handleSaveErrorDraft = (error) => {
        if(error)
            switch(error){
                case 'Parent folder is less permissive than new folder':
                    setConfirmModal({
                        ...confirmModal,
                        show: true,
                        title: "Vuoi procedere?",
                        text: "La cartella di livello superiore ha dei permessi più stringenti, vuoi procedere ugualente? Aggiorneremo la cartella con i nuovi permessi",
                        onConfirm: ()=>handleSaveDraft(true,true),
                        onClose: ()=>closeConfirmModal(),
                        closeCta: t.buttons.back,
                        confirmCta: "Procedi"
                    })
                break;
                case 'New folder permissions will make impossible for a children folder to be accessed by someone':
                    setConfirmModal({
                        ...confirmModal,
                        show: true,
                        title: "Vuoi procedere?",
                        text: "I permessi di accesso impostati renderanno impossibile ad alcuni utenti l'accesso alle cartelle presenti",
                        onConfirm: ()=>handleSaveDraft(true,true),
                        onClose: ()=>closeConfirmModal(),
                        closeCta: t.buttons.back,
                        confirmCta: "Procedi comunque"
                    })
                break;
                default:
                    setConfirmModal({
                        ...confirmModal,
                        show: true,
                        title: "Vuoi procedere?",
                        text: `Errore durante il salvataggio della cartella: ${error}`,
                        onConfirm: ()=>handleSaveDraft(true,true),
                        onClose: ()=>closeConfirmModal(),
                        closeCta: t.buttons.back,
                        confirmCta: "Procedi comunque"
                    })
            }
        else
            toast.error("Errore durante il salvataggio della cartella")
    }

    const handleSaveError = (error) => {
        if(error)
            switch(error){
                case 'Parent folder is less permissive than new folder':
                    setConfirmModal({
                        ...confirmModal,
                        show: true,
                        title: "Vuoi procedere?",
                        text: "La cartella di livello superiore ha dei permessi più stringenti, vuoi procedere ugualente? Aggiorneremo la cartella con i nuovi permessi",
                        onConfirm: ()=>handlePubblishFolder(true,true),
                        onClose: ()=>closeConfirmModal(),
                        closeCta: t.buttons.back,
                        confirmCta: "Procedi"
                    })
                break;
                case 'New folder permissions will make impossible for a children folder to be accessed by someone':
                    setConfirmModal({
                        ...confirmModal,
                        show: true,
                        title: "Vuoi procedere?",
                        text: "I permessi di accesso impostati renderanno impossibile ad alcuni utenti l'accesso alle cartelle presenti",
                        onConfirm: ()=>handlePubblishFolder(true,true),
                        onClose: ()=>closeConfirmModal(),
                        closeCta: t.buttons.back,
                        confirmCta: "Procedi comunque"
                    })
                break;
                default:
                    setConfirmModal({
                        ...confirmModal,
                        show: true,
                        title: "Vuoi procedere?",
                        text: `Errore durante il salvataggio della cartella: ${error}`,
                        onConfirm: ()=>handlePubblishFolder(true,true),
                        onClose: ()=>closeConfirmModal(),
                        closeCta: t.buttons.back,
                        confirmCta: "Procedi comunque"
                    })
            }
        else
            toast.error("Errore durante il salvataggio della cartella")
    }

    const handleSaveDraft = async (_,force=false) => {
        let _folderData = structuredClone(folderData)
        _folderData = prepareFolderData(_folderData)
        const response = await fetchEditFolder({folder_id: folder_id, force_update: force}, _folderData)
        if(response.success){
            toast.success(t.folder.draft_saved)
            setConfirmModal({
                ...confirmModal,
                show: false
            })
            dispatch(loadOperations())
        } else {
            if(response.error){
                handleSaveErrorDraft(response.error)
            } else {
                toast.error("Errore durante il salvataggio della cartella")
            }
        }
    }

    const handlePubblishFolder = async (_,force=false) => {
        dispatch(setLoading(true))
        let _folderData = structuredClone(folderData)
        _folderData = prepareFolderData(_folderData)
        _folderData['state'] = "ready"
        const response = await fetchEditFolder({folder_id: folder_id, force_update: force}, _folderData)
        if(response.success){
            toast.success(t.folder.folder_published)
            setConfirmModal({
                ...confirmModal,
                show: false
            })
            loadFolderDetails()
            dispatch(loadOperations())
        } else {
            if(response.error){
                handleSaveError(response.error)
            } else
                toast.error("Errore durante la pubblicazione della cartella")
        }
        dispatch(setLoading(false))
    }

    const deleteFolder = async () => {
        let _folderData = structuredClone(folderData)
        _folderData = prepareFolderData(_folderData)
        _folderData['state'] = "deleted"
        const response = await fetchEditFolder({folder_id: folder_id}, _folderData)
        if(response.success){
            toast.success(t.folder.folder_deleted)
            setConfirmModal({
                ...confirmModal,
                show: false
            })
            navigate(`/folder/${folderData.parent_folder_id}`,{replace:true})
        } else {
            toast.error("Errore durante l'eliminazione della cartella")
        }
    }

    const askDeleteFolder = () => {
        setConfirmModal({
            ...confirmModal,
            title: t.folder.confirm_delete_folder,
            text: t.folder.confirm_delete_folder_text,
            show: true,
            onConfirm: ()=>deleteFolder(),
            onClose: ()=>closeConfirmModal(),
            closeCta: t.buttons.back,
            confirmCta: t.buttons.delete
        })
    }

    const closeConfirmModal = () => {
        setConfirmModal({
            ...confirmModal,
            show: false
        })
    }

    const handleFolderDataChange = (data) => {
        setFolderData(data)
        setIsupdated(true)
    }

    //Drag&Drop
    const sensors = useSensors(
        useSensor(PointerSensor, { activationConstraint: { distance: 10 } }),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );

    const copyFolderUrl = () => {
        if(navigator.clipboard.writeText(`${BASE_URL}/folder/${folder_id}`))
        toast.success(t.home.copied_link)
    }

    const handleDragEndFiles = (event) => {
        const { active, over } = event;
        if (active.id !== over.id) {
            const oldIndex = folderData.files.findIndex(file => file.file_id === active.id);
            const newIndex = folderData.files.findIndex(file => file.file_id === over.id);
            const updatedFiles = arrayMove(folderData.files, oldIndex, newIndex);
            console.log(updatedFiles);
            
            setFolderData({
                ...folderData,
                files: updatedFiles,
            });
        }
    };

     const handleDragEndVideos = (event) => {
        const { active, over } = event;
        if (active.id !== over.id) {
            const oldIndex = folderData.videos.findIndex(file => file.file_id === active.id);
            const newIndex = folderData.videos.findIndex(file => file.file_id === over.id);
            const updatedFiles = arrayMove(folderData.videos, oldIndex, newIndex);
            
            setFolderData({
                ...folderData,
                videos: updatedFiles,
            });
        }
    };

    const handleDragEndLinks = (event) => {
        const { active, over } = event;
        if (active.id !== over.id) {
            const oldIndex = folderData.links.findIndex(file => file.file_id === active.id);
            const newIndex = folderData.links.findIndex(file => file.file_id === over.id);
            const updatedFiles = arrayMove(folderData.links, oldIndex, newIndex);
            
            setFolderData({
                ...folderData,
                links: updatedFiles,
            });
        }
    };

    const userOnboarding  = useSelector(selectUserOnboarding)
    const userData = useSelector(selectUserData)
    const { setIsOpen, setCurrentStep, setSteps, setMeta, isOpen } = useTour()

    const restartTour = () => {
        if(userOnboarding?.trainings?.section_completed){
            setIsOpen(true)
            setSteps(trainingsTourSteps(folder_id))
            setCurrentStep(3)
            setMeta('trainings')
        } else {
            setSteps(trainingsTourSteps(folder_id))
            setCurrentStep(userOnboarding?.trainings?.step_completed_count)
            setMeta('trainings')
            setIsOpen(true)
        }
    }
    
    useEffect(()=>{
        setIsOpen(false)
        if(!userData?.is_super_admin){
            if(
                (
                    !userOnboarding?.trainings?.section_completed 
                )
                && userOnboarding?.trainings?.step_completed_count > 2){
                setTimeout(()=>{
                    if(window.location.pathname?.includes("folder"))
                        setIsOpen(true)
                },2000)
                setSteps(trainingsTourSteps(folder_id))
                setCurrentStep(userOnboarding?.trainings?.step_completed_count)
                setMeta('trainings')
            } else if(userOnboarding?.trainings?.step_completed_count === 2 && 
                (
                    !userOnboarding?.trainings?.section_completed 
                    || (
                        userOnboarding?.trainings?.section_completed &&
                        userOnboarding?.trainings?.step_completed_count < 7
                    )
                )
            ) {
                dispatch(
                    updateUserOnboarding({
                        onboarding_step: {
                            step_completed_count: 3,
                            section_completed: false,
                            section: 'trainings'
                        }
                    })
                );
                setTimeout(()=>{
                    if(window.location.pathname?.includes("folder"))
                        setIsOpen(true)
                },2000)
                setSteps(trainingsTourSteps(folder_id))
                setCurrentStep(3)
                setMeta('trainings')
            }
        }
    },[])

    useEffect(()=>{
        loadFolderDetails()
    },[folder_id])
    

    return(
        <div className="folder_content">
            <div className="folder_header">
                <>
                    <Link to={folderData?.parent_folder_id ? `/folder/${folderData?.parent_folder_id}`: '/'}>
                        <img src={arrow_back_img} alt='' style={{verticalAlign:'middle'}}/>
                        <span>{t.buttons.back}</span>
                    </Link>
                </>
                <div className="d-flex justify-content-between">
                <div className="page_title pointer trainigs-step-3" onClick={()=>{setShowInfoModal(true)}} >
                    {
                        folderData?.icon_url &&
                            <img src={`${API_URL}${folderData.icon_url}`} style={{maxWidth:"24px"}} />
                    }
                    <h1 className="ms-2">{folderData?.name} <img src={edit_img} alt="" style={{verticalAlign:'middle'}} /></h1>
                </div>
                <FolderInfo 
                    folderData={folderData} 
                    setFolderData={setFolderData} 
                    show={showInfoModal} 
                    onClose={()=>{setShowInfoModal(false)}} 
                />
                <div className="d-flex align-items-center">
                    <Dropdown>
                        <Dropdown.Toggle as={'div'} bsPrefix="custom" split={true} id="dropdown-basic">
                            <button>
                                {t.folders.add}
                                <img src={add_img} />
                            </button>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item >
                                <Link to={`/folder/create/${folderData?.folder_id}`}>
                                    <img src={folder_img} className="me-1"/>
                                    {t.folders.folder}
                                </Link>
                            </Dropdown.Item>
                            <Dropdown.Item disabled={folderData?.training } >
                                <Link to={`/training/details/${folderData?.folder_id}`}>
                                    <img src={training_img} className="me-1"/>
                                    {t.folders.training}
                                </Link>
                            </Dropdown.Item>
                            <Dropdown className="dropdown-item" >
                                <Dropdown.Toggle as={'span'}  id="dropdown-nested">
                                        <img src={lesson_img} className="me-1" />
                                        {t.folders.material}
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item  onClick={()=>handleAddContent('file')}>
                                        <img src={file_img} className="me-1"/>
                                        {t.folder.file}
                                    </Dropdown.Item>
                                    <Dropdown.Item  onClick={()=>handleAddContent('video')}>
                                        <img src={video_img} className="me-1"/>
                                        {t.folder.video}
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={()=>handleAddContent('link')} >
                                        <img src={link_img} className="me-1"/>
                                        {t.folder.link}
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Dropdown.Menu>
                    </Dropdown>
                    <div className="ms-4 align-items-center d-flex pointer trainigs-step-7 fw-bold" onClick={()=>{setShowPermissionsModal(true)}}>
                        {t.folder.users}
                        <img src={users_img} alt="" style={{width:'24px'}} className="ms-1"/>
                    </div>
                    <div className="ms-4 align-items-center d-flex pointer fw-bold" onClick={copyFolderUrl}>
                        {t.folder.links}
                        <img src={copy_link_img} alt="" className="ms-1" />
                    </div>
                    <div className="ms-3 align-items-center d-flex pointer border-start border-2 ps-3 fw-bold" onClick={askDeleteFolder}>
                        {t.folder.delete_folder}
                        <img src={trash_img} alt="" className="ms-1" />
                    </div>
                </div>
                
                </div>
                
            </div>
            {
                folderData?.state === "deleted" &&
                    <div className="folder_alert">
                        <div className="d-flex align-items-start">
                            <img src={eye_img} />
                            <div className="ms-2">
                                <h3>{t.folder.folder_deleted_state}</h3>
                                <p className="mb-0">{t.folder.folder_deleted_text}</p>
                            </div>
                        </div>
                    </div>
            }
            {
                folderData?.state === "draft" &&
                    <div className="folder_alert">
                        <div className="d-flex align-items-start">
                            <img src={eye_img} />
                            <div className="ms-2">
                                <h3>{t.folder.folder_draft_state}</h3>
                                <p className="mb-0">{t.folder.folder_draft_text}</p>
                            </div>
                        </div>
                    </div>
            }
            <div className="d-flex justify-content-between">
                <div className="trainigs-step-4">
                    <h2>{t.folder.training}</h2>
                    {
                    folderData?.training ?
                        <div className={`folder_quiz `}>
                            <div className='folder__content h-100'>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <h3 className="mb-0">{folderData?.training?.training_title}</h3> 
                                    <Link to={`/training/details/${folderData?.folder_id}`}>
                                       <img src={right_img} className="ms-3" alt="" />
                                    </Link>
                                    
                                </div>
                                <hr />
                                <div className="d-flex align-items-center justify-content-between">
                                    <span>
                                        <img src={training_img} alt="" style={{verticalAlign:'middle'}} /> {folderData?.training?.questions?.length} {t.training.questions}
                                    </span>
                                    <span className='status_label' style={{color:`${EXAMS_STATUS[folderData?.training?.ready ? 'ready' : 'draft']?.color}`, background: `${EXAMS_STATUS[folderData?.training?.ready ? 'ready' : 'draft']?.background}`}}>
                                        {!folderData?.training?.ready && <img src={edit_grey_img} className='me-1' style={{maxWidth:'18px', verticalAlign:'middle'}}/>}
                                        {t.exams[folderData?.training?.ready ? 'ready' : 'draft']}
                                    </span> 
                                </div>
                                
                            </div>
                        </div>
                    : <div className="new_element reduced">
                            <div>
                                <img src={training_img} alt=""/>
                                <h3 style={{color:"#6D6F73"}}>{t.folder.new_traininig}</h3>
                                <Link to={`/training/create/${folderData?.folder_id}`}>
                                    <button className="secondary mx-auto mt-3">{t.folder.add} <img src={add_blue_img} /></button>
                                </Link>
                            </div>
                        </div>
                    }
                </div>
                {
                    !isOpen &&
                    <div className='demo-activator' onClick={restartTour}>
                        <img src={question_img} />
                    </div>
                }
            </div>
                <div className="trainigs-step-6">
                <h2 className="mt-3">{t.folder.folders} <Link to={`/folder/create/${folderData?.folder_id}`}><img style={{verticalAlign:'middle'}} src={add_circle_img} /></Link></h2>
                    {folderData.folder_id ? 
                        <div className="mt-2">
                            <SubFolders  
                                parentFolder={folderData} 
                                additionalElement={
                                    <div className="new_element">
                                        <div>
                                            <img src={folder_img} alt=""/>
                                            <h3 style={{color:"#6D6F73"}}>{t.folder.new_folder}</h3>
                                            <Link to={`/folder/create/${folderData?.folder_id}`}>
                                                <button className="secondary mx-auto mt-3">{t.folder.add} <img src={add_blue_img} /></button>
                                            </Link>
                                        </div>
                                    </div>
                                }
                            />
                        </div> : null
                    }
                </div>
                <h2 className="mt-5 d-flex align-items-center">{t.folder.materials} 
                    <Dropdown className="dropdown-item ms-2 pointer" >
                        <Dropdown.Toggle as={'span'} className="no-arrow-dropdown pointer" id="dropdown-nested">
                                <img style={{verticalAlign:'middle'}} src={add_circle_img} />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item  onClick={()=>handleAddContent('file')}>
                                <img src={file_img} className="me-1"/>
                                {t.folder.file}
                            </Dropdown.Item>
                            <Dropdown.Item  onClick={()=>handleAddContent('video')}>
                                <img src={video_img} className="me-1"/>
                                {t.folder.video}
                            </Dropdown.Item>
                            <Dropdown.Item onClick={()=>handleAddContent('link')} >
                                <img src={link_img} className="me-1"/>
                                {t.folder.link}
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown></h2>
                <div className="folder-content trainigs-step-5">
                    {
                        ( !folderData?.videos || folderData?.videos?.length === 0 ) &&
                        ( !folderData?.files ||folderData?.files?.length === 0 ) &&
                        ( !folderData?.links ||  folderData?.links?.length === 0) ?
                            <span>Nessun materiale presente</span>
                        : ""
                    }
                    { folderData?.videos?.length > 0 && <>
                        <h2 className="mt-3">{t.folder.video} <img style={{verticalAlign:'middle'}} src={add_circle_img} onClick={()=>handleAddContent('video')} /></h2>
                        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEndVideos}>
                            <SortableContext items={folderData.videos.map(file => file.file_id)} strategy={rectSortingStrategy}>
                                <div className="file_list mb-3">
                                    {folderData.videos.map((file, file_index) => (
                                        <SortableItem id={file.file_id} key={file.file_id}>
                                            <File type={'video'} onClick={() => openContent('videos', file_index)} file={file} />
                                        </SortableItem>
                                    ))}
                                </div>
                            </SortableContext>
                        </DndContext>
                    </> }
                    { folderData?.files?.length > 0 && <>
                        <h2 className="">{t.folder.file} <img style={{verticalAlign:'middle'}} src={add_circle_img} onClick={()=>handleAddContent('file')} /></h2>
                        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEndFiles}>
                            <SortableContext items={folderData.files.map(file => file.file_id)} strategy={rectSortingStrategy}>
                                <div className="file_list mb-3">
                                    {folderData.files.map((file, file_index) => (
                                        <SortableItem id={file.file_id} key={file.file_id}>
                                            <File type={'file'} onClick={() => openContent('files', file_index)} file={file} />
                                        </SortableItem>
                                    ))}
                                </div>
                            </SortableContext>
                        </DndContext>
                    </> }
                    { folderData?.links?.length > 0 && <>
                        <h2 className="">{t.folder.link} <img style={{verticalAlign:'middle'}} src={add_circle_img} onClick={()=>handleAddContent('link')} /></h2>
                        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEndLinks}>
                            <SortableContext items={folderData.links.map(file => file.file_id)} strategy={rectSortingStrategy}>
                                <div className="file_list mb-3">
                                    {folderData.links.map((file, file_index) => (
                                        <SortableItem id={file.file_id} key={file.file_id}>
                                            <File type={'link'} onClick={() => openContent('links', file_index)} file={file} />
                                        </SortableItem>
                                    ))}
                                </div>
                            </SortableContext>
                        </DndContext>
                    </> }
                </div>
                <footer className='control-footer'>
                    <div className='d-flex align-items-center justify-content-end'>
                        <div className='d-flex justify-content-end'>
                            {
                                folderData.state === "draft" &&
                                    <button className='secondary' onClick={handleSaveDraft}>
                                        {t.buttons.save_draft}
                                    </button>
                            }
                            {
                                folderData.state === "deleted" &&
                                    <button onClick={handleSaveDraft}>
                                        {t.buttons.restore_and_draft}
                                    </button>
                            }
                            {
                                (folderData.state === "ready" || folderData.state === "draft")  &&
                                    <button  className={isUpdated ? "ms-2 highlight" :'ms-2'} onClick={handlePubblishFolder}>
                                        {t.buttons.save_and_pubblish}
                                    </button>
                            }
                        </div>
                    </div>
                </footer>
                <ConfirmModal props={confirmModal}/>
                <ContentEditModal 
                    folderData={folderData} 
                    type={selectedContent.type} 
                    index={selectedContent.index} 
                    show={selectedContent.show} 
                    onClose={handleCloseSelectedContent} 
                    onFolderDataChange={handleFolderDataChange} 
                />
                <ContentCreateModal  
                    show={contentModal.show} 
                    type={contentModal.type} 
                    folderData={folderData || null} 
                    onClose={handleCloseContentModal} 
                />
                <FolderPermissions 
                    show={showPermissionsModal} 
                    onClose={handleClosePermissionsModal} 
                    folderData={folderData || null} 
                    onFolderDataChange={handleFolderDataChange} 
                    handleSaveFolder={handleSaveDraft}
                />
          </div>
    )
}

function SortableItem(props) {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: props.id });
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };
    
    return (
        <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
            {props.children}
        </div>
    );
}